import { roleConstants } from '../../_constants';

export function roles(state = {}, action) {
    switch (action.type) {
        case roleConstants.ROLE_FETCHING:
            return {
                ROLEfetching: true
            };
        case roleConstants.ROLE_FETCHED:
            return {
                ROLEfetching: false
            };
        case roleConstants.GET_ACTIVE_ROLES:
            return {
                roles: action.roles,
                rolesSelection: true
            };
        case roleConstants.GET_ROLES:
            return {
                roles: action.roles,
            };
        case roleConstants.GET_ROLE_BY_ID:
            return {
                role: action.role
            };
        case roleConstants.UPDATE_ROLE:
            return {
                updating: true
            };
        case roleConstants.SEARCH_ROLE:
            return {
                roles: action.roles
            };
        default:
            return state;
    }
}